// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18f4e119","453":"23b17040","732":"500df43a"}[chunkId] + ".chunk.js";
};